<template>
	<div class="recommendations">
		<div v-if="loading" class="p-4 text-center">
			<span class="text-gray-500">Empfehlungen werden geladen...</span>
		</div>
		<div v-else-if="error" class="p-4 text-center">
			<span class="text-red-500">{{ error }}</span>
		</div>
		<div v-else-if="recommendations.length === 0" class="p-4 text-center">
			<span class="text-gray-500">Keine Empfehlungen verfügbar.</span>
		</div>
		<div v-else class="grid grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
			<RecommendationItem
					v-for="recommendation in displayedRecommendations"
					:key="recommendation.id"
					:recommendation="recommendation"
			/>
		</div>
	</div>
</template>

<script lang="ts" setup>
import {computed, onMounted, ref} from "vue"
import {getRecommendations} from "@/js/api/sp"
import {RecommendationInterface} from "@/js/interfaces/recommendation"
import {tailwindBreakpoints} from "@/js/utils/tailwindBreakpoints"
import RecommendationItem from "./RecommendationItem.vue"

const props = defineProps<{
	eventId: number
}>()

const recommendations = ref<RecommendationInterface[]>([])
const loading = ref<boolean>(true)
const error = ref<string | null>(null)
const screenWidth = ref<number>(typeof window !== 'undefined' ? window.innerWidth : 1024)

const displayedRecommendations = computed(() => {
	let maxItems = 3

	if (screenWidth.value >= tailwindBreakpoints['2xl']) {
		maxItems = 12
	} else if (screenWidth.value >= tailwindBreakpoints.xl) {
		maxItems = 10
	} else if (screenWidth.value >= tailwindBreakpoints.lg) {
		maxItems = 8
	} else if (screenWidth.value >= tailwindBreakpoints.md) {
		maxItems = 6
	}

	return recommendations.value.slice(0, maxItems)
})

const handleResize = () => {
	screenWidth.value = window.innerWidth
}

onMounted(async () => {
	try {
		recommendations.value = await getRecommendations(props.eventId)
	} catch (e) {
		console.error("Failed to load recommendations:", e)
		error.value = "Empfehlungen konnten nicht geladen werden."
	} finally {
		loading.value = false
	}

	window.addEventListener('resize', handleResize)
})
</script>
